/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React, { useState } from 'react'
import { Dropdown, Menu, Spin } from 'antd'
import { saveAs } from 'file-saver'

import { useWorker } from 'workers'

const defaultText = 'Export (.xlsx)'

const RemoteXlsxExport = ({
  type = 'primary',
  getWorksheets,
  fileName = 'report',
  btnStyle,
  text = defaultText,
  size,
  ...rest
}) => {
  const [loading, setLoading] = useState(false)

  const [fileWriter] = useWorker({
    getWorkerInstance: () =>
      new Worker('workers/file-worker.js', {
        type: 'module',
      }),
  })

  async function generateExcel() {
    setLoading(true)
    const worksheets = await getWorksheets()

    const fileBlob = await fileWriter.writeToExcel(worksheets)
    saveAs(fileBlob, fileName)
    setLoading(false)
  }

  async function generateCSV() {
    setLoading(true)
    const worksheets = await getWorksheets()

    await worksheets.forEach(async ws => {
      const blob = await fileWriter.writeToCSV(ws)
      saveAs(blob, (ws.name || fileName) + '.csv')
    })
    setLoading(false)
  }

  const menu = (
    <Menu
      onClick={({ key }) => {
        if (key === 'csv') {
          generateCSV()
        } else {
          generateExcel()
        }
      }}
    >
      <Menu.Item key="csv">CSV</Menu.Item>
      <Menu.Item key="excel">Excel</Menu.Item>
    </Menu>
  )
  return (
    <Spin spinning={loading}>
      <Dropdown.Button
        type={type}
        style={btnStyle}
        title={defaultText}
        size={size}
        overlay={menu}
        onClick={() => generateExcel()}
        {...rest}
      >
        {text}
      </Dropdown.Button>
    </Spin>
  )
}
export default RemoteXlsxExport
